import { ContentBlock } from '@/components/ContentBlock/ContentBlock';
import { SearchSlice } from '@/redux/modules/search/search.types';

type Props = {
    seoSearchTermData: SearchSlice['seoSearchTerm'];
};

export const SearchPageSeoTitleAndCopy = ({ seoSearchTermData }: Props) => {
    if (!seoSearchTermData?.seoCopy || !seoSearchTermData?.seoTitle) {
        return null;
    }

    return (
        <div className="mx-auto mt-xl max-w-[796px]">
            <ContentBlock
                content={seoSearchTermData.seoCopy}
                title={seoSearchTermData.seoTitle}
            />
        </div>
    );
};
